import {GuruEntity} from './guru-entity';
import {EntityLineHeader} from '../entity/entity-line-header';

export class MassUpdate {
  lines!: EntityLineHeader[];
  updatedEntities!: GuruEntity[];
}
